module.exports = __webpack_public_path__ + "static/media/19.2c8167d2.jpg";